module.exports = __webpack_public_path__ + "static/ring_of_water_walking-0c80aa6a43b0b810dd3a7c6b13ef312e.jpeg";